export default __webpack_public_path__ + "static/media/10.Single-Jacket-Lay-flat-Fire-Hose.ed9c483b.png";